import Page from './index';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	// auth: authRoles.user,
	routes: [
		{
			path: '/standard-reports',
			exact: true,
			component: Page.StandardReportLayout
		},
		{
			path: '/custom-reports',
			exact: true,
			component: Page.CustomReportLayout
		},
	]
};